import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { SaveDemandeValidationPjDocumentDraftGQL } from '@graphql/generated';
import { GedService } from '@lib/ged/ged.service';
import { PieceJustificativeDocumentType } from '@lib/models/demande-validation-pj/types/piece-justificative-document-types.type';
import { DemandeValidationPjDraftDefInput } from '@graphql/generated';
import { PieceJustificativeDocumentTypeMapper } from '@lib/mappers/graphql/piece-justificative-document-type-mapper';
import { DocumentGedSectionMapper } from '@lib/mappers/graphql/document-ged-section-mapper';
import { DocumentBoSectionType } from '@lib/models/documents/document-consultant-section';

@Injectable({ providedIn: 'root' })
export class ConsultantDocumentSubmissionService {
  private readonly gedService = inject(GedService);
  private readonly saveDraftGql = inject(SaveDemandeValidationPjDocumentDraftGQL);

  async saveDemandeValidationPj(
    file: File | undefined,
    documentType: PieceJustificativeDocumentType,
    draft: DemandeValidationPjDraftDefInput,
    publicId: string | null,
    section?: DocumentBoSectionType | null,
    codeConsultant?: string | null
  ): Promise<void> {
    const document = file
      ? {
          documentType: PieceJustificativeDocumentTypeMapper.toGraphQl(documentType),
          files: [{ fileName: file.name }],
        }
      : null;
    const demande = { publicId, document, ...draft };

    const queryResult = await lastValueFrom(
      this.saveDraftGql.mutate({
        variables: {
          draft: demande,
          section: DocumentGedSectionMapper.toGraphQl(section),
          codeConsultant,
        },
      })
    );

    const fileWriteAccesses =
      queryResult.data?.demandeValidationPjCreateOrUpdate
        .demandeValidationPjCreateOrUpdateResponse?.fileWriteAccesses ?? [];

    for (const fileWriteAccess of fileWriteAccesses) {
      if (file) {
        await this.gedService.uploadFile(file, fileWriteAccess.uploadUri);
      }
    }
  }
}
